"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toolbox_ab_testing_1 = require("@zapier/toolbox-ab-testing");
const lodash_1 = require("lodash");
function useBinaryBandit(name, options = { shouldSkip: false }) {
    const banditConfig = {
        name,
        options: ['control', 'experiment'],
    };
    const banditOptions = {
        shouldSkip: options.shouldSkip,
    };
    const { isLoading: isBanditLoading, result } = toolbox_ab_testing_1.useBandit(banditConfig, banditOptions);
    const shouldShowBanditExperiment = lodash_1.get(result, ['recommendation', 0]) === 'experiment';
    return { isBanditLoading, shouldShowBanditExperiment };
}
exports.default = useBinaryBandit;
